import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';
import { useSprintBurndown } from '../../hooks/useDashboard';
import Spinner from '../ui/Spinner';

interface Props {
  projectId: string;
  projectType: string;
}

export default function BurndownWidget({ projectId, projectType }: Props) {
  const { data, isLoading } = useSprintBurndown(projectId);

  if (projectType !== 'SCRUM') {
    return (
      <div className="h-full flex flex-col">
        <h3 className="text-sm font-semibold text-gray-700 mb-2">스프린트 번다운</h3>
        <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
          Scrum 프로젝트에서만 사용 가능합니다.
        </div>
      </div>
    );
  }

  if (isLoading) {
    return <div className="flex items-center justify-center h-full"><Spinner className="size-6" /></div>;
  }

  const bd = data?.data;
  if (!bd || bd.issueCount === 0) {
    return (
      <div className="h-full flex flex-col">
        <h3 className="text-sm font-semibold text-gray-700 mb-2">스프린트 번다운</h3>
        <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
          스토리 포인트가 설정된 작업이 없습니다.
        </div>
      </div>
    );
  }

  // 간이 번다운 데이터 (현재 스냅샷 기반)
  const completionRate = bd.totalPoints > 0 ? Math.round((bd.completedPoints / bd.totalPoints) * 100) : 0;

  const chartData = [
    { day: '시작', ideal: bd.totalPoints, actual: bd.totalPoints },
    { day: '현재', ideal: bd.totalPoints / 2, actual: bd.remainingPoints },
    { day: '목표', ideal: 0, actual: null },
  ];

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-gray-700">스프린트 번다운</h3>
        <span className="text-sm text-gray-500">
          {bd.completedPoints}/{bd.totalPoints} SP ({completionRate}%)
        </span>
      </div>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" />
          <XAxis dataKey="day" tick={{ fontSize: 11 }} stroke="#9CA3AF" />
          <YAxis tick={{ fontSize: 11 }} stroke="#9CA3AF" />
          <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
          <ReferenceLine y={0} stroke="#10B981" strokeDasharray="3 3" />
          <Area
            type="monotone"
            dataKey="ideal"
            stroke="#9CA3AF"
            fill="none"
            strokeDasharray="5 5"
            strokeWidth={2}
            name="이상선"
          />
          <Area
            type="monotone"
            dataKey="actual"
            stroke="#3B82F6"
            fill="#DBEAFE"
            strokeWidth={2}
            name="실제"
            connectNulls={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
